/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { useSelector } from 'react-redux';
import ReactHTMLParser from 'react-html-parser';
import { makeStyles } from '@material-ui/core';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Accordion from '@material-ui/core/Accordion';
import Typography from '@material-ui/core/Typography';
import Icons from '../assets/Icons';
import { getBrand } from '../../../../../../../state/ducks/App/ducks/Brand/Brand-Selectors';

const useStyles = () => makeStyles((theme) => ({
    accordianWrapper: {
        zIndex: '1',
        [theme?.breakpoints?.up('md')]: {
            maxWidth: '928px',
            margin: '0 auto',
        },
        '& .MuiAccordionSummary-expandIconWrapper': {
            color: 'rgb(0 0 0 / 0%)',
        },
        '& .MuiAccordion-root': {
            boxShadow: 'none',
            borderRadius: 'unset !important',
            margin: '15px 0 32px 0',
        },
        '& .MuiAccordion-root.Mui-expanded': {
            margin: '15px 0 20px 0 !important',
        },
        '& .MuiAccordionSummary-root': {
            borderBottom: '1px solid #2F2F2F',
            minHeight: '50px !important',
            [theme?.breakpoints?.up('md')]: {
                minHeight: '55px !important',
            },
        },
        '& .MuiButtonBase-root.MuiAccordionSummary-root.Mui-expanded': {
            minHeight: '50px !important',
            [theme?.breakpoints?.up('md')]: {
                minHeight: '55px !important',
            },
        },
        '& .MuiAccordionSummary-content.Mui-expanded': {
            margin: '15px 0 !important',
        },
        '& p, h3': {
            marginBottom: '0px',
            color: '#555555',
        },
        '& p': {
            fontFamily: 'inherit',
            fontSize: '12px!important',
            '& a': {
                color: 'inherit',
                fontSize: '12px!important'
            },
        },
        '& .title': {
            fontWeight: '700',
            fontSize: '14px',
        },
        '& .details': {
            fontWeight: '400',
            fontSize: '12px',
        },
    }
}));

const Footer = () => {
    const classesLayout = useStyles();
    const classes = classesLayout();

    const [expanded, setExpanded] = React.useState(false);

    const brand = useSelector(getBrand);

    const footerContentAsPerBrand = {
        '18F': "This <a href ='https://www.1800flowers.com/fathersday'>Father's Day</a> look no further for the perfect gift addition than with 1-800-Flowers.com AI-powered dad joke generator! Using advanced machine learning algorithms, this unique gift allows you to personalize the dad jokes to your own dad's sense of humor. Imagine the smile on his face as he reads the hilariously witty puns, clever one-liners, and playful jokes all generated by AI! Not only is this a thoughtful and humorous gift, but it's also a great conversation starter that will keep your family entertained for hours on end. These dad jokes are the perfect addition to any Father's Day gift from Father's Day flowers to Father's Day gift baskets!",
        HD: "This <a href='https://www.harryanddavid.com/h/fathers-day-gifts'>Father's Day</a>, why not add a tech-savvy twist to the traditional dad joke as the perfect addition to your gift this year? Thanks to advances in artificial intelligence, Harry & David makes it easy to generate hilariously cringeworthy one-liners for Dad! So give the gift of AI-generated dad humor this Father's Day!",
        '18B': "Looking for a unique and personalized way to surprise your dad this Father's Day? Look no further than with AI generated dad jokes from 1-800-Baskets.com! Tap into the power of artificial intelligence to generate custom dad jokes that pair perfectly with <a href='https://www.1800baskets.com/fathers-day-gift-baskets-11176'>Father's Day gift baskets</a>! ",
        CCO: "This year add an innovative addition to any <a href='https://www.cheryls.com/fathers-day-cookie-gifts'>Father's Day gift</a> that will certainly bring a smile to his face - AI generated dad jokes! That's right, thanks to advancements in artificial intelligence, you can now have hilarious dad jokes generated in an instant that are guaranteed to make dad laugh! Simply input your favorite topics, and the AI will take care of the rest. ",
        TPF: "As Father's Day approaches, we are all on the hunt for the perfect gift that will make our dads smile. This year, why not take it up a notch by using the latest AI technology to create personalized dad jokes paired with a delicious <a href='https://www.thepopcornfactory.com/fathers-day-gifts'>Father's Day popcorn gift</a>? It's the perfect way to show him how much you know and appreciate his unique sense of humor!",
        SCH: "This <a href='https://www.simplychocolate.com/fathers-day-chocolate'>Father's Day</a>, make your dad laugh with the help of AI! Thanks to advances in artificial intelligence technology, you can now generate hilarious dad jokes at the click of a button with Simply Chocolate's Dad joke generator! ",
        SY: "Looking for a unique and humorous gift for Dad this Father's Day? Look no further than using AI to generate Dad jokes with Stockyards Dad joke generator! These jokes are perfectly paried with <a href='https://www.stockyards.com/s/fathers-day-gifts'>Father's Day gifts</a> this year! ",
        WLF: "Looking for a fun way to celebrate your dad this <a href='https://www.wolfermans.com/w/fathers-day-gifts'>Father's Day?</a> Look no further than the power of AI to write hilarious dad jokes which pair perfectly with Father's Day gifts! This year, why not give your dad the gift of laughter with a collection of personalized dad jokes, all created with the help of artificial intelligence!",
        FB: "Who doesn't love a good dad joke? Dad jokes make the perfect addition to your Father's Day gift and this year it has never been easier than with Fruit Bouquet's dad joke generator! These jokes pair perfectly with <a href='https://www.fruitbouquets.com/fathers-day-fruit-arrangements-400116005'>Father's Day fruit arrangements</a>! ",
        BRY: "So, whether he's a fan of dad jokes, one-liners, or even cheesy puns, use Shari's Berries Dad joke generator to leverage AI to write dad jokes this year! These jokes will be the perfect addition to this year's <a href='https://www.berries.com/fathers-day-gifts-sf1'>Father's Day gift</a>!",
        VC: "This <a href='https://www.vitalchoice.com/v/occasion-gifting/fathers-day'>Father's Day</a>, why not add a tech-savvy twist to the traditional dad joke as the perfect addition to your gift this year? Thanks to advances in artificial intelligence, Vital Choice makes it easy to generate hilariously cringeworthy one-liners for Dad! So give the gift of AI-generated dad humor this Father's Day!",
    };

    const h3Message = brand.domain === '1800flowers' ? '1-800-Flowers.com Dad Joke GPT' : 'Learn more about Dad Joke GPT';

    return (
        <div className={classes.accordianWrapper}>
            <Accordion expanded={expanded} onChange={() => {
                if (!expanded) setExpanded(true);
                else setExpanded(false);
            }}>
                <AccordionSummary
                    expandIcon={<Icons icon={expanded ? "expandLess" : "expandMore"} />}
                    aria-controls="panel1bh-content"
                    id="panel1bh-header"
                >
                    <Typography variant='h3' className='title'>{h3Message}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography className='details'>
                        {ReactHTMLParser(footerContentAsPerBrand[brand.code])}
                    </Typography>
                </AccordionDetails>
            </Accordion>
        </div>
    )
}

export default Footer
